export default "__VITE_ASSET__7bdbca01__"